import axios from "axios";
import { setupCache } from 'axios-cache-interceptor';
import queryString from "query-string";
import config from "../config";
import { createValueStore } from '../hooks/useLocalStorage';

const { api } = config;

// axios 1.15 changed default array param serialization in a way the back-end's
// qs parser can't decode — see VER-563 fix c4d811b05. Set the serializer on the
// instance so every GET inherits arrayFormat: 'repeat' by default rather than
// each new endpoint needing to remember to opt in.
const Axios = axios.create({
  baseURL: api.baseUrl,
  paramsSerializer: (params) => queryString.stringify(params, { arrayFormat: "repeat" }),
});

setupCache(Axios, {
  methods: ['get'],
  headerInterpreter: (headers) => {
    const cacheControl = headers['cache-control'];
    const maxAgeMatch = cacheControl.match(/max-age=(\d+)/);
    
    if (maxAgeMatch) {
      return parseInt(maxAgeMatch[1], 10) * 1000; 
    }
    
    return 'not enough headers';
  },
  cachePredicate: (response) => {
    return !!response.headers['cache-control'];
  },
});

Axios.interceptors.response.use(
    (response) => {
      return response;
    },
    (error) => {
      if (!!error.response?.data.error && error.response.data.message.toLowerCase() === 'session timed out or invalid') {
        const accessTokenCache = createValueStore('token');
        accessTokenCache.remove();
      }
      return Promise.reject(error);
    }
)

export default Axios;
